import Asset from '@advisor/models/Asset';

export default class Portfolio {
  constructor(data) {
    this.assets = [];
    this.chartData = [];
    // Flag to track negative value in dataset
    this.hasNegativeValues = false;

    if (!data) {
      return;
    }

    // Set flag to true, if any value in dataset is negative
    this.hasNegativeValues = data.datasets[0].data.some((val) => parseFloat(val) < 0);

    // Set proper value to `this.assets` and `this.chartData` only if flag is false;
    // Else both will remain empty
    if (!this.hasNegativeValues) {
      data.labels.forEach((label, index) => {
        this.assets[data.labels[index]] = new Asset({
          tickers: data.tickers[index],
          color: data.datasets[0].backgroundColor[index],
          percentage: data.datasets[0].data[index],
          label: data.labels[index],
        });

        this.chartData.push({
          data: [Number(data.datasets[0].data[index])],
          backgroundColor: data.datasets[0].backgroundColor[index],
          label: data.labels[index],
        });
      });
    }
  }
}
